/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Col, Row } from 'antd';
import React, { ReactElement, useMemo } from 'react';
import { GeneralFunction } from 'types/common';

import { ActionButtonContainer, UserInfoTextStyled } from './styled';

const CardBodyMobile: React.FC<{
  onDelete?: GeneralFunction;
  onEdit?: GeneralFunction;
  onRedirect?: GeneralFunction;
  main?: string | ReactElement;
  sub?: string | ReactElement;
  extra?: (string | ReactElement)[];
  status?: string;
  statusTooltipColor?: string;
  statusTooltip?: string;
  rightSide?: string | ReactElement;
}> = ({ onRedirect, onDelete, onEdit, main, sub, extra, rightSide }) => {
  const ActionTypeComponent = useMemo(() => {
    if (!onRedirect && !onEdit && !onDelete) return null;
    return (
      <>
        {onRedirect && (
          <Col span={6}>
            <div className='gx-dot-arrow' onClick={onRedirect}>
              <div className='gx-bg-primary gx-hover-arrow'>
                <i className='icon icon-long-arrow-right gx-text-white' />
              </div>
              <div className='gx-dot'>
                <i className='icon icon-ellipse-v gx-text-primary' />
              </div>
            </div>
          </Col>
        )}
        {onDelete && (
          <Col span={6} className='gx-d-flex gx-justify-content-center gx-align-items-center'>
            <ActionButtonContainer className='gx-dot gx-p-1' onClick={onDelete} $iconOnHoverColor='red'>
              <i className='icon icon-trash gx-text-grey' />
            </ActionButtonContainer>
          </Col>
        )}
        {onEdit && (
          <Col span={6} className='gx-d-flex gx-justify-content-center gx-align-items-center'>
            <ActionButtonContainer className='gx-dot gx-p-1' onClick={onEdit} $iconOnHoverColor='#038fde'>
              <i className='icon icon-edit gx-text-grey' />
            </ActionButtonContainer>
          </Col>
        )}
      </>
    );
  }, [onDelete, onEdit, onRedirect]);

  const generateExtraSection = (ex: any, i: number) => (
    <UserInfoTextStyled key={i}>
      <div className='gx-mb-2 gx-text-grey gx-fs-md'>{ex}</div>
    </UserInfoTextStyled>
  );

  return (
    <div className='gx-p-3 custom-card-body gx-flex-column gx-h-100'>
      <div className='gx-font-weight-medium gx-mb-2'>{main}</div>
      <div className='gx-font-weight-medium gx-mb-2'>{sub}</div>
      <div className='gx-mb-2'>{extra && extra.map(generateExtraSection)}</div>
      <Row align='middle' justify='center'>
        {ActionTypeComponent}
      </Row>
      <div style={{ justifySelf: 'flex-end', flex: 1 }}>{rightSide}</div>
    </div>
  );
};

export default React.memo(CardBodyMobile);
